import React from "react";
import "./dialog-text-list.css";
import { DialogTextListItem } from "../dialog-text-list-item/dialog-text-list-item";

export class DialogTextList extends React.Component {
  render() {
    const data = this.props.dialogData;
    const rows = data.map(elem => (
      <div className="dialog-text-list__row">
        <div className="dialog-text-list__policeman">
          <DialogTextListItem person={elem.person[0]} text={elem.text[0]} />
        </div>
        <div className="dialog-text-list__you">
          <DialogTextListItem person={elem.person[1]} text={elem.text[1]} />
        </div>
      </div>
    ));
    return <div id="dialogList" className="dialog-text-list">{rows}</div>;
  }
}
